/**
 * Stripe API base URL for checkout and portal.
 * - Local: empty string → relative paths hit the proxy (localhost:4242)
 * - Dev (tujus-pwa-dev.web.app): Cloud Functions URL
 * - Production (experienceapp.io / tujud-pwa.web.app): Cloud Functions URL
 */
export function getStripeApiBaseUrl() {
  if (typeof window === "undefined") return "";

  const host = window.location.hostname;

  if (host === "localhost" || host === "127.0.0.1") {
    return ""; // Proxy forwards /create-checkout-session to localhost:4242
  }

  if (host === "tujus-pwa-dev.web.app") {
    return "https://europe-west1-tujus-pwa-dev.cloudfunctions.net";
  }

  const isProductionHost =
    host === "experienceapp.io" ||
    host === "www.experienceapp.io" ||
    host === "tujud-pwa.web.app" ||
    host === "tujud-pwa.firebaseapp.com";

  if (isProductionHost) {
    return "https://europe-west1-tujud-pwa.cloudfunctions.net";
  }

  // Fallback for ngrok or other dev hosts
  if (host.includes("ngrok")) {
    return "https://europe-west1-tujus-pwa-dev.cloudfunctions.net";
  }

  return "";
}

export function getStripeCheckoutUrl() {
  const base = getStripeApiBaseUrl();
  return base ? `${base}/createCheckoutSession` : "/create-checkout-session";
}

export function getStripePortalUrl() {
  const base = getStripeApiBaseUrl();
  return base ? `${base}/createPortalSession` : "/create-portal-session";
}

export function getProductsUrl() {
  const base = getStripeApiBaseUrl();
  return base ? `${base}/getProducts` : "/api/products";
}
